import { render, staticRenderFns } from "./HomeFeedSingleMenu.vue?vue&type=template&id=a82fdfd0&scoped=true"
import script from "./HomeFeedSingleMenu.vue?vue&type=script&lang=js"
export * from "./HomeFeedSingleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a82fdfd0",
  null
  
)

export default component.exports